import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeaderLayout } from '../../../components/Header/Redesign';
import { useEventBus } from '../../../hooks/useEventBus';
import { useIsMainPage } from '../../../hooks/useIsMainPage';
import { IApplicationState } from '../../../types/redux';
import { AuthenticationModalContainer } from '../../AuthenticationModalContainer';
import { DropdownContainer } from '../../DropdownContainer';
import { DropdownBackdropContainer } from '../../DropdownContainer/DropdownBackdropContainer';
import { HamburgerContainer } from '../../HamburgerContainer';
import { LogoContainer } from '../../LogoContainer';
import { NavBarContainer } from '../../NavBarContainer/Redesign';
import { UserRelatedContainer } from '../../UserRelatedContainer';

export const HeaderContainer: React.FC = () => {
  useEventBus();

  const noResize = useSelector((state: IApplicationState) => state.noResize);
  const buttonRef = React.useRef<HTMLButtonElement | null>(null);
  const navbarRef = React.useRef<HTMLDivElement | null>(null);
  const isNeedDivider = !useIsMainPage();

  const content = (
    <>
      {!noResize && (
        <Responsive phone tablet>
          <HamburgerContainer />
        </Responsive>
      )}
      <LogoContainer />
      <UserRelatedContainer />
      <AuthenticationModalContainer />
    </>
  );

  const navbar = noResize ? (
    <NavBarContainer navbarRef={navbarRef} />
  ) : (
    <Responsive desktop>
      <NavBarContainer navbarRef={navbarRef} />
    </Responsive>
  );

  return (
    <>
      <HeaderLayout noResize={noResize} content={content} navbar={navbar} isNeedDivider={isNeedDivider}>
        <DropdownContainer menuRef={buttonRef} navbarRef={navbarRef} />
      </HeaderLayout>
      <DropdownBackdropContainer />
    </>
  );
};
